import React from 'react';
import './HomeScreen.css';

export default function HomeScreen() {
  const homeUrl = process.env.REACT_APP_HOME_URL;

  return (
    <div className="home-screen">
      <h1>Susitikimas nerastas...</h1>
      <p>
        Spauskite{' '}
        <a href={homeUrl} style={{ color: 'white' }}>
          ant šios nuorodas
        </a>{' '}
        norėdami grįžti į pagrindinį puslapį.
      </p>
    </div>
  );
}
